import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const ExternalLinkIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 24, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

ExternalLinkIcon.displayName = 'ExternalLinkIcon'
